import React, { Component } from 'react';
import './Spinner.css';
import ParameterErrors from '../errors/ParameterErrors';
const  {throwNotProvided, throwNotOfType} = ParameterErrors;
export default class Spinner extends Component {
	constructor(props){
		super(props)
		const{spinnerHandles, invertHandles}=props;
		if(invertHandles===undefined||invertHandles===null)
			this._invertHandles = false;
		else 
			this._invertHandles = invertHandles;
		
		this._spinnerHandles = spinnerHandles;
		this._spinnerHandlesChanged = this._spinnerHandlesChanged.bind(this);
		spinnerHandles.addEventListener('change', this._spinnerHandlesChanged);
		this.state={visible:false};
	}
	_spinnerHandlesChanged(e){
		const visible = this._invertHandles?(!e.hasHandles):e.hasHandles;
		this.setState({visible:visible});
	}
	render() {
		let className ="spinner";
		if(this.state.visible)
			className+=" visible";
		return (<div className={className} onClick={this._handleClick}>
				<div/>
				<div/>
				<div/>
			</div>);
	}
}
